// BarberAppointmentsTable.jsx
import React from "react";

export default function BarberAppointmentsTable({
  appointments,
  today,
  deleteAppointment,
  calculateEndTime,
  convertTime,
  formatDate,
}) {
  return (
    <div className="mt-6 w-full">
      <h3 className="text-lg sm:text-xl font-semibold mb-2 text-zinc-50 text-center" >Termini</h3>
      <div className="overflow-auto border border-neutral-700 rounded-md">
        <table className="w-full table-auto text-sm sm:text-base">
          <thead className="bg-neutral-800">
            <tr>
              <th className="px-4 py-2 text-left text-zinc-50">Date</th>
              <th className="px-4 py-2 text-left text-zinc-50">Time</th>
              <th className="px-4 py-2 text-left text-zinc-50">Client Name</th>
              <th className="px-4 py-2 text-left text-zinc-50">Service</th>
              <th className="px-4 py-2 text-left text-zinc-50">Remove</th>
            </tr>
          </thead>
          <tbody>
            {appointments
              .filter(
                (appointment) => new Date(appointment.appointmentDate) >= today
              )
              .map((appointment) => (
                <tr
                  key={appointment.appointmentId}
                  className="border-b border-neutral-700"
                >
                  <td className="px-4 py-2 text-zinc-50">
                    {appointment.appointmentDate
                      ? formatDate(appointment.appointmentDate)
                      : "N/A"}
                  </td>
                  <td className="px-4 py-2 text-zinc-50">
                    {appointment.appointmentTime
                      ? convertTime(appointment.appointmentTime)
                      : "N/A"}
                    {appointment.serviceName === null
                      ? "-" +
                        calculateEndTime(
                          appointment.appointmentTime,
                          appointment.appointmentDuration
                        )
                      : ""}
                  </td>
                  <td className="px-4 py-2 text-zinc-50">
                    {`${appointment.clientName ?? ""} ${
                      appointment.clientSurname ?? ""
                    }`.trim() ||
                      (appointment.note === "BREAK"
                        ? "Pauza"
                        : appointment.note || "Pauza")}
                  </td>
                  <td className="px-4 py-2 text-zinc-50">
                    {appointment.serviceName ?? "Pauza"}
                  </td>
                  <td className="px-4 py-2 text-zinc-50">
                    <button
                      onClick={() => {
                        if (appointment.appointmentId) {
                          deleteAppointment(appointment.appointmentId);
                        } else {
                          console.error(
                            "Appointment ID is undefined:",
                            appointment
                          );
                        }
                      }}
                      className="px-2 py-1 bg-red-500 text-white rounded text-xs sm:text-sm"
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
